import { changeEnquiryStatus, saveEnquiryData } from '../utils/api'
//import { showLoading, hideLoading } from 'react-redux-loading'

export const RECEIVE_ENQUIRIES = 'RECEIVE_ENQUIRIES'
export const CHANGE_STATUS = 'CHANGE_STATUS'
export const ADD_ENQUIRY_COMMENT = 'ADD_ENQUIRY_COMMENT'
//export const ADD_ENQUIRY = 'ADD_ENQUIRY'

export function receiveEnquiries (enquiries) {
	return {
		type: RECEIVE_ENQUIRIES,
		enquiries
	}
}

function changeStatus ({ id, statusId }) {
	return {
		type: CHANGE_STATUS,
		id,
		statusId
	}
}

function addEnquiryComment (id, comment) {
	return {
		type: ADD_ENQUIRY_COMMENT,
		id,
		comment
	}
}

export function handleChangeStatus (id, statusId, userId) {
	return (dispatch) => {

		return changeEnquiryStatus(id, statusId, userId)
			.then((comment) => {
				dispatch(changeStatus({id, statusId}))
				dispatch(addEnquiryComment(id, comment))
			})
	}
}

/*export function updateEnquiry (enquiry) {
	return {
		type: UPDATE_ENQUIRY,
		enquiry
	}
}*/

export function handleSaveEnquiry (enquiryId, data) {
	return (dispatch, getState) => {
		const { authedUser } = getState()
		const userId = authedUser.id

		//dispatch(showLoading())

		return saveEnquiryData(
			enquiryId,
			data,
			userId
		)
		/*.then((enquiry) => {
			dispatch(updateEnquiry(enquiry))
		})*/
		//.then(() => dispatch(hideLoading()))
	}
}


// WEBPACK FOOTER //
// ./src/actions/enquiries.js